// extracted by mini-css-extract-plugin
module.exports = {"main":"Home_main__VkIEL","title":"Home_title__hYX6j","tabContainer":"Home_tabContainer__OWE3m","tabContent":"Home_tabContent__rLu5Q","lk-button":"Home_lk-button__3Zhcv"};